import React from 'react';
import { Outlet } from 'react-router-dom';

const ThemeTest = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ThemeTest;
